import { render, staticRenderFns } from "./FieldInfoTypeMaterial.vue?vue&type=template&id=f4d83ae2&scoped=true"
import script from "./FieldInfoTypeMaterial.vue?vue&type=script&lang=js"
export * from "./FieldInfoTypeMaterial.vue?vue&type=script&lang=js"
import style0 from "./FieldInfoTypeMaterial.vue?vue&type=style&index=0&id=f4d83ae2&prod&scoped=true&lang=scss"
import style1 from "./FieldInfoTypeMaterial.vue?vue&type=style&index=1&id=f4d83ae2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d83ae2",
  null
  
)

export default component.exports